// Metadata map: links violation detail keys to discipline and category
export const VIOLATIONS: Record<string, { discipline: string[]; category?: string; phase?: string }> = {
  // § 125 Start
  'para_125.delayed_position': { discipline: ['all'], category: 'start' },
  'para_125.provoked_false_start': { discipline: ['all'], category: 'start' },
  'para_125.no_dive': {
    discipline: ['freestyle', 'breaststroke', 'butterfly', 'medley'],
    category: 'start',
  },
  'para_125.false_start': { discipline: ['all'], category: 'start' },

  // § 126 Freistilschwimmen
  'para_126.no_wall_touch': { discipline: ['freestyle'], category: 'turn' },
  'para_126.over_15m': { discipline: ['freestyle'], category: 'underwater' },
  'para_126.submerged': { discipline: ['freestyle'], category: 'during_race' },

  // § 127 Rückenschwimmen
  'para_127.toes_over_edge': { discipline: ['backstroke'], category: 'start' },
  'para_127.backstroke_ledge': { discipline: ['backstroke'], category: 'start' },
  'para_127.over_15m': { discipline: ['backstroke'], category: 'underwater' },
  'para_127.submerged': { discipline: ['backstroke'], category: 'during_race' },
  'para_127.left_back_position': { discipline: ['backstroke'], category: 'during_race' },
  'para_127.delayed_turn': { discipline: ['backstroke'], category: 'turn' },
  'para_127.no_wall_touch': { discipline: ['backstroke'], category: 'turn' },
  'para_127.left_wall_early': { discipline: ['backstroke'], category: 'turn' },
  'para_127.not_on_back': { discipline: ['backstroke'], category: 'finish' },

  // § 128 Brustschwimmen
  'para_128.not_breast_position': { discipline: ['breaststroke'], category: 'body_position' },
  'para_128.arm_not_simultaneous': { discipline: ['breaststroke'], category: 'arm_movement' },
  'para_128.elbows_above_water': { discipline: ['breaststroke'], category: 'arm_movement' },
  'para_128.hands_past_hip': { discipline: ['breaststroke'], category: 'arm_movement' },
  'para_128.leg_not_simultaneous': { discipline: ['breaststroke'], category: 'leg_movement' },
  'para_128.feet_not_turned_out': { discipline: ['breaststroke'], category: 'leg_movement' },
  'para_128.not_two_hands': { discipline: ['breaststroke'], category: 'hand_touch' },
  'para_128.head_not_breaking_surface': { discipline: ['breaststroke'], category: 'head_movement' },
  'para_128.multiple_underwater_pulls': { discipline: ['breaststroke'], category: 'dive_phase' },
  'para_128.dolphin_after_breast': { discipline: ['breaststroke'], category: 'dive_phase' },
  'para_128.cycle_violation': { discipline: ['breaststroke'], category: 'arm_leg_cycle' },

  // § 129 Schmetterlingsschwimmen
  'para_129.over_15m': { discipline: ['butterfly'], category: 'dive_depth' },
  'para_129.not_breast_position': { discipline: ['butterfly'], category: 'body_position' },
  'para_129.not_at_surface': { discipline: ['butterfly'], category: 'surface_position' },
  'para_129.arm_not_simultaneous': { discipline: ['butterfly'], category: 'arm_movement' },
  'para_129.flutter_kick': { discipline: ['butterfly'], category: 'leg_movement' },
  'para_129.breaststroke_kick': { discipline: ['butterfly'], category: 'leg_movement' },
  'para_129.left_wall_early': { discipline: ['butterfly'], category: 'turn' },
  'para_129.not_two_hands': { discipline: ['butterfly'], category: 'hand_touch' },

  // § 130 Lagenschwimmen
  'para_130.wrong_order': { discipline: ['medley'], category: 'stroke_order' },
  'para_130.incorrect_turn': { discipline: ['medley'], category: 'transition' },
  'para_130.wrong_stroke': { discipline: ['medley'], category: 'freestyle_section' },

  // § 131 Wettkampf
  'para_131.illegal_equipment': { discipline: ['general'], category: 'equipment' },
  'para_131.incomplete_distance': { discipline: ['general'], category: 'distance' },
  'para_131.pulled_on_lane_rope': { discipline: ['general'], category: 'lane_violation' },
  'para_131.wrong_stroke': { discipline: ['general'], category: 'stroke_violation' },
  'para_131.left_lane': { discipline: ['general'], category: 'lane_violation' },
  'para_131.no_wall_touch': { discipline: ['general'], category: 'turn' },
  'para_131.standing_not_allowed': { discipline: ['general'], category: 'standing' },
  'para_131.walking': { discipline: ['general'], category: 'standing' },
  'para_131.unauthorized_entry': { discipline: ['general'], category: 'pool_entry' },
  'para_131.interference': { discipline: ['general'], category: 'interference' },

  // § 130 / 131 Staffel
  'para_130_131.early_departure': { discipline: ['relay'], category: 'premature_start' },
  'para_130_131.unlisted_swimmer': { discipline: ['relay'], category: 'wrong_swimmer' },
  'para_130_131.incorrect_order': { discipline: ['relay'], category: 'wrong_order' },
  'para_130_131.swimmer_twice': { discipline: ['relay'], category: 'extra_swimmer' },
  'para_130_131.delayed_exit': { discipline: ['relay'], category: 'pool_exit' },
  'para_130_131.premature_pool_entry': { discipline: ['relay'], category: 'early_pool_entry' },
}

export const DECISION_TREE = new Map([
  [
    'freestyle',
    {
      q1: { text: 'when_violation', options: ['start', 'turn', 'during_race'] },
      start: {
        text: 'start_type',
        options: ['delayed_position', 'provoked_false_start', 'no_dive', 'false_start'],
      },
      turn: { text: 'turn_issue', options: ['no_wall_touch', 'over_15m'] },
      during_race: { text: 'during_race_issue', options: ['over_15m', 'submerged'] },
    },
  ],
  [
    'backstroke',
    {
      q1: { text: 'when_violation', options: ['start', 'turn', 'during_race', 'finish'] },
      start: { text: 'start_issue', options: ['toes_over_edge', 'backstroke_ledge', 'over_15m', 'false_start'] },
      turn: { text: 'turn_issue', options: ['delayed_turn', 'no_wall_touch', 'left_wall_early', 'over_15m'] },
      during_race: { text: 'during_race_issue', options: ['submerged', 'left_back_position', 'over_15m'] },
      finish: { text: 'finish_issue', options: ['not_on_back'] },
    },
  ],
  [
    'breaststroke',
    {
      q1: {
        text: 'which_aspect',
        options: [
          'body_position',
          'arm_movement',
          'leg_movement',
          'hand_touch',
          'head_movement',
          'dive_phase',
          'arm_leg_cycle',
        ],
      },
      body_position: { text: 'body_position_issue', options: ['not_breast_position'] },
      arm_movement: {
        text: 'arm_movement_issue',
        options: ['arm_not_simultaneous', 'elbows_above_water', 'hands_past_hip'],
      },
      leg_movement: { text: 'leg_movement_issue', options: ['leg_not_simultaneous', 'feet_not_turned_out'] },
      hand_touch: { text: 'hand_touch_issue', options: ['not_two_hands'] },
      head_movement: { text: 'head_movement_issue', options: ['head_not_breaking_surface'] },
      dive_phase: { text: 'dive_phase_issue', options: ['multiple_underwater_pulls', 'dolphin_after_breast'] },
      arm_leg_cycle: { text: 'arm_leg_cycle_issue', options: ['cycle_violation'] },
    },
  ],
  [
    'butterfly',
    {
      q1: {
        text: 'which_aspect',
        options: [
          'dive_depth',
          'body_position',
          'arm_movement',
          'leg_movement',
          'surface_position',
          'hand_touch',
          'turn',
        ],
      },
      dive_depth: { text: 'dive_depth_issue', options: ['over_15m'] },
      body_position: { text: 'body_position_issue', options: ['not_breast_position'] },
      arm_movement: { text: 'arm_movement_issue', options: ['arm_not_simultaneous'] },
      leg_movement: { text: 'leg_movement_issue', options: ['flutter_kick', 'breaststroke_kick'] },
      surface_position: { text: 'surface_position_issue', options: ['not_at_surface'] },
      hand_touch: { text: 'hand_touch_issue', options: ['not_two_hands'] },
      turn: { text: 'turn_issue', options: ['left_wall_early'] },
    },
  ],
  [
    'medley',
    {
      q1: { text: 'stroke_phase', options: ['stroke_order', 'transition', 'freestyle_section'] },
      stroke_order: { text: 'stroke_order_issue', options: ['wrong_order'] },
      transition: { text: 'transition_issue', options: ['incorrect_turn'] },
      freestyle_section: { text: 'freestyle_section_issue', options: ['wrong_stroke'] },
    },
  ],
  [
    'relay',
    {
      q1: {
        text: 'relay_violation_type',
        options: ['premature_start', 'wrong_swimmer', 'wrong_order', 'extra_swimmer', 'pool_exit', 'early_pool_entry'],
      },
      premature_start: { text: 'premature_start_issue', options: ['early_departure'] },
      wrong_swimmer: { text: 'wrong_swimmer_issue', options: ['unlisted_swimmer'] },
      wrong_order: { text: 'wrong_order_issue', options: ['incorrect_order'] },
      extra_swimmer: { text: 'extra_swimmer_issue', options: ['swimmer_twice'] },
      pool_exit: { text: 'pool_exit_issue', options: ['delayed_exit'] },
      early_pool_entry: { text: 'early_pool_entry_issue', options: ['premature_pool_entry'] },
    },
  ],
  [
    'general',
    {
      q1: {
        text: 'general_category',
        options: [
          'equipment',
          'lane_violation',
          'interference',
          'distance',
          'turn',
          'standing',
          'pool_entry',
          'stroke_violation',
        ],
      },
      equipment: { text: 'equipment_issue', options: ['illegal_equipment'] },
      lane_violation: { text: 'lane_violation_issue', options: ['pulled_on_lane_rope', 'left_lane'] },
      interference: { text: 'interference_issue', options: ['interference'] },
      distance: { text: 'distance_issue', options: ['incomplete_distance'] },
      turn: { text: 'turn_issue', options: ['no_wall_touch'] },
      standing: { text: 'standing_issue', options: ['standing_not_allowed', 'walking'] },
      pool_entry: { text: 'pool_entry_issue', options: ['unauthorized_entry'] },
      stroke_violation: { text: 'stroke_violation_issue', options: ['wrong_stroke'] },
    },
  ],
])
